<template>
  <v-card
    outlined
    class="count-card"
    @click="$router.push({ path: '/product/list' })"
  >
    <v-card-text class="count-card-content">
      <div class="count-icon-box">
        <v-icon color="primary">mdi-package-variant-closed</v-icon>
      </div>

      <div class="count-info">
        <div class="count-label">Products</div>

        <v-progress-circular
          v-if="isLoading"
          size="28"
          width="3"
          color="primary"
          indeterminate
          class="mt-2"
        />

        <animated-number
          v-else
          class="count-value"
          :value="count"
          :formatValue="formatToNumber"
          :duration="1000"
        />
      </div>

      <v-icon color="#94a3b8">mdi-chevron-right</v-icon>
    </v-card-text>
  </v-card>
</template>

<script>
import AnimatedNumber from "animated-number-vue";
import productService from "@/modules/Product/service";

export default {
  name: "product-tile",

  components: {
    AnimatedNumber,
  },

  data() {
    return {
      isLoading: true,
      count: 0,
    };
  },

  created() {
    this.getList();
  },

  methods: {
    formatToNumber(value) {
      return `${Number(value || 0).toFixed(0)}`;
    },

    async getList() {
      this.isLoading = true;

      try {
        const response = await productService.getAll({
          limit: 1,
          offset: 0,
        });

        this.count = Number(response.count || 0);
        return response;
      } catch (error) {
        console.error("product count failed", error);
        this.count = 0;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.count-card {
  border-radius: 20px;
  background: #ffffff;
  cursor: pointer;
  transition: 0.2s ease;
}

.count-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.count-card-content {
  min-height: 128px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
}

.count-icon-box {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: #eff6ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.count-info {
  flex: 1;
  min-width: 0;
}

.count-label {
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
}

.count-value {
  font-size: 34px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
}
</style>